module.exports = __webpack_public_path__ + "static/media/74.356ed2d2.gif";